const doc = [({"da":({"js":({"routes":({"admin":({"email_templates":({"previews":({"index":({"add_new_email_template_preview":"Opret ny forhåndsvisning"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;